module.exports = __webpack_public_path__ + "img/salesman_index_posterBtn.04a04ed7.png";